import { useContext, useMemo } from "react";
import { ConfigurationObjectInterpolationContext } from "./interpolation/ConfigurationObjectInterpolationContext";
import { createConfigurationAttributeGroupTranslators } from "./translators/createConfigurationAttributeGroupTranslators";
import { createConfigurationAttributeTranslators } from "./translators/createConfigurationAttributeTranslators";
import { createConfigurationObjectTranslators } from "./translators/createConfigurationObjectTranslators";
import { createConfigurationTranslators } from "./translators/createConfigurationTranslators";
import { createConfigurationValueTranslators } from "./translators/createConfigurationValueTranslators";
import { useTranslatorOptions } from "./useTranslatorOptions";
/**
 * Provides translator functions
 * - configuration object name and description
 * - attribute name and description
 * - value name and description
 * - info markdown on all oft those
 *
 *
 * Notes
 * - uses the configuration language
 * @deprecated Translations are included in state
 * @category Translation
 * @returns
 */
export function useConfigurationTranslators() {
    const options = useTranslatorOptions();
    const variables = useContext(ConfigurationObjectInterpolationContext);
    return useMemo(() => {
        return createConfigurationTranslators(options, variables);
    }, [options, variables]);
}
/**
 * Provides translator functions for configuration objects
 * - name and description
 * - info markdown
 *
 * Notes
 * - uses the configuration language
 *
 * @category Translation
 * @deprecated Translations included in state
 * @returns
 */
export function useConfigurationObjectTranslators() {
    const options = useTranslatorOptions();
    return useMemo(() => createConfigurationObjectTranslators(options), [options]);
}
/**
 * Provides translator functions for configuration attributes
 * - name and description
 * - info markdown
 *
 * Notes
 * - uses the configuration language
 *
 * @deprecated Translations included in state
 * @category Translation
 * @returns
 */
export function useConfigurationAttributeTranslators() {
    const options = useTranslatorOptions();
    return useMemo(() => createConfigurationAttributeTranslators(options), [options]);
}
/**
 * Provides translator functions for configuration values
 * - name and description
 * - info markdown
 *
 * Notes
 * - uses the configuration language
 *
 * @deprecated Translations included in state
 * @category Translation
 * @returns
 */
export function useConfigurationValueTranslators() {
    const options = useTranslatorOptions();
    return useMemo(() => createConfigurationValueTranslators(options), [options]);
}
/**
 * Provides translator functions for configuration values
 * - name and description
 * - info markdown
 *
 * Notes
 * - uses the configuration language
 *
 * @category Translation
 * @returns
 */
export function useConfigurationAttributeGroupTranslators() {
    const options = useTranslatorOptions();
    const variables = useContext(ConfigurationObjectInterpolationContext);
    return useMemo(() => createConfigurationAttributeGroupTranslators(options, variables), [options, variables]);
}
//# sourceMappingURL=useConfigurationTranslators.js.map